import "./ContentHeroColumnContent.scss";

import React from "react";

import { Grid2 } from "@mui/material";

import { ContentHeroColumn } from "../../models/app-data-model";
import Button from "../button/Button";
import EmbeddableContent from "../embeddable-content/EmbeddableContent";
import GlobalImage from "../global-image/GlobalImage";
import RichTextBlock from "../rich-text-block/RichTextBlock";

export type ContentHeroColumnContentProps = {
  contentHeroColumn: ContentHeroColumn;
};

const ContentHeroColumnContent: React.FC<ContentHeroColumnContentProps> = ({ contentHeroColumn }) => {
  return <Grid2 size={{ xs: 12, md: 'grow' }} columnSpacing={2} className='content-hero-column-content'>
    {
      contentHeroColumn.column_content.map((content, index) => {
        return <>
          {content.rich_text && <RichTextBlock key={index} content={content.rich_text.copy} />}

          {content.image && <GlobalImage key={index} globalImageData={content.image}/>}

          {content.button && <Button key={index} reference={content.button.reference}
            link={content.button.link}
            className={content.button.button_type}
            label={content.button.label} />}

          {content.embeddable_content && <EmbeddableContent
            key={index} embedContentData={content.embeddable_content} featureToggles={[]} />}
        </>
      })
    }
  </Grid2>;
};

export default ContentHeroColumnContent;
